var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":_vm.title,"ok-title":_vm.$t('global.yes'),"ok-only":""},on:{"ok":function($event){return _vm.$emit('confirmed')}},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',[_vm._v(_vm._s(this.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }